import { IncludeType } from '../../../common';
import { ProductWithAttributes } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches attributes for multiple groups by their IDs.
 *
 * @param groupIds - An array of group IDs to fetch attributes for.
 * @param locale - The locale for the market.
 * @param includeType - Specifies the type of attributes to include (default is `IncludeType.Available`).
 * @returns A promise that resolves to an array of `ProductWithAttributes` or `null` if no data is found.
 */
export const getGroupsAttributes = async (
  groupIds: number[],
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<ProductWithAttributes[] | null> => {
  try {
    if (!groupIds.length) {
      console.warn('No group IDs provided for fetching attributes.');
      return null;
    }

    const queryParams = new URLSearchParams({
      ids: groupIds.join('|'),
      include: includeType,
      marketLocale: locale,
    }).toString();

    const url = `/group/attributes?${queryParams}`;
    const response = await productCatalogueHttp.get<ProductWithAttributes[]>(url);

    return response?.data?.length ? response.data : null;
  } catch (error) {
    console.error(`Failed to fetch group attributes for groupIds: ${groupIds.join(', ')}`, error);
    return null;
  }
};
